export default {
  async get ({ commit, rootState }) {
    const response = await rootState.$stratus.services.api.get('/services')
    commit('setServices', { rootState, services: response.results })
    return response.results
  }
}
